import {Component, Injector} from "@angular/core";
import {SupplierSearchModel} from "../supplier-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {SupplierSearchPageComponent} from "../supplier-search-page/supplier-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-supplier-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(SupplierSearchModel),
        registerSearchControl(SupplierMultiSelectSearchControlComponent)
    ]
})
export class SupplierMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<SupplierSearchModel> {
    constructor(model: SupplierSearchModel, injector: Injector) {
        super(model, injector, "vendorId", "name");

        this.extendedSearchComponent = SupplierSearchPageComponent;
    }
}
